export default __webpack_public_path__ + "images/half-price-november.jpg";